// Les libellés venant de Notion sont préfixés d'un émoji ("🆕 Nouveau",
// "🔄 Review (Révision)"). L'interface n'utilisant plus d'émojis, on le retire
// à l'affichage — sans toucher à la donnée, qui reste la clé côté Notion.
export const stripEmoji = (value) =>
  String(value || '').replace(/^[^\p{L}\p{N}]+/u, '').trim();

// "🔄 Review (Révision)" → "Révision" : on préfère le libellé français
// quand Notion fournit les deux.
export const shortLabel = (value) => {
  const clean = stripEmoji(value);
  const inParens = clean.match(/\(([^)]+)\)\s*$/);
  return inParens ? inParens[1] : clean;
};

// Sur iOS, une poignée de sélection tirée hors d'un champ déborde sur le
// document : la copie ramène la valeur saisie *suivie du texte rendu de
// l'écran* (libellés du formulaire, puis barre de navigation). Recollé dans le
// champ, cela a produit des traductions du type
// "ሓንቲ ነገር እንተደኣ ኣለያ  🔊 Prononciation (optionnel) … ⚙️Paramètres".
// Aucun de ces fragments n'appartient à une traduction : on les détecte au
// moment d'enregistrer, avant que la valeur ne parte dans Notion.
const UI_CHROME = [
  'Prononciation',
  'Contexte / Exemple',
  'Créer la Carte',
  'Enregistrer dans Notion',
  'Deck *',
  'Accueil',
  'Stats',
  'Révision',
  'Assistant IA',
  'Bibliothèque',
  'Paramètr',
];

// Position du premier fragment d'interface, ou -1 si la valeur est saine.
const uiChromeIndex = (value) => {
  const text = String(value || '');
  const hits = UI_CHROME.map((m) => text.indexOf(m)).filter((i) => i >= 0);
  return hits.length ? Math.min(...hits) : -1;
};

export const hasUIChrome = (value) => uiChromeIndex(value) >= 0;

// Coupe au premier fragment d'interface rencontré : ce qui précède est la
// saisie réelle, ce qui suit est la capture d'écran parasite. La coupe tombe
// sur le libellé ("Stats"), pas sur l'icône ni sur le mot tronqué qui le
// précèdent ("⚙️", "eil") : on rogne ensuite la fin jusqu'au guèze.
export const stripUIChrome = (value) => {
  const text = String(value || '');
  const cut = uiChromeIndex(text);
  if (cut < 0) return text.trim();

  let head = text.slice(0, cut);
  let previous;
  do {
    previous = head;
    head = head
      .replace(/[\s\p{Extended_Pictographic}\p{S}️‍]+$/u, '')
      .replace(/[A-Za-z]+$/u, '');
  } while (head !== previous);

  return head.trim();
};
